import { z } from 'zod';
/**
 * The day view: everything that landed in a user's mailboxes on one date.
 *
 * Days are UTC calendar days throughout, matching how `daily_stats` buckets
 * them. Anything else would make the detail page disagree with the dashboard
 * row it was opened from.
 */
export const dayParamSchema = z.object({
    day: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected a date in YYYY-MM-DD form'),
});
//# sourceMappingURL=dayDetail.js.map